<template>
  <header class="container-fluid">
    <div class="fixed">
      <b-row align-v="center" class="bg-primary shadow-lg py-2">
        <b-col>
          <b-btn
            @click="goBack"
            variant="none"
            v-b-tooltip.hover.down="'Cliquer pour revenir en arrière'"
          >
            <b-icon icon="chevron-left" variant="light"></b-icon>
          </b-btn>
        </b-col>
        <b-col cols="7" class="text-center text-white text-ellipsis">
          <b-btn @click="moveToByUrl" variant="none" v-if="routeIsAnswer">
            <b-icon
              icon="arrow-return-left"
              variant="light"
              v-b-tooltip.hover.left="'Retour'"
            ></b-icon>
          </b-btn>
          <span v-b-toggle.dlibr-title-sidebar>
            {{ dlibr.title }}
          </span>
        </b-col>
        <b-col class="text-right">
          <div class="position-relative">
            <b-btn
              v-if="isTeacher"
              class="d-none d-lg-inline-block"
              @click="toggleMode"
              pill
              :variant="flowDlibr.evalMode ? 'outline-info' : 'outline-light'"
            >
              <b-icon
                v-if="flowDlibr.evalMode"
                variant="info"
                icon="check-circle-fill"
              ></b-icon>
              <span>
                Mode évaluation
              </span>
            </b-btn>
            <span
              class="fa-stack suggestion-icon 
              top animate__animated 
              animate__slower
              animate__infinite
              animate__flash"
              v-b-toggle.filters-menu
              v-if="isStudent && jobs.showSuggestionIcon"
            >
              <font-awesome-icon
                :icon="['fas', 'circle']"
                class="text-warning fa-stack-2x"
                transform=" shrink-4"
              />
              <font-awesome-icon
                :icon="['far', 'lightbulb']"
                class="text-white fa-stack-1x"
                transform=" shrink-1"
              />
            </span>
            <b-btn
              variant="none"
              v-b-toggle.filters-menu
              v-b-tooltip.hover.down="'Filtrer les commentaires'"
            >
              <b-icon
                icon="funnel-fill"
                variant="light"
                flip-h
                v-if="!isFilter"
              ></b-icon>
              <b-iconstack class="msg-type-icon" v-else>
                <b-icon
                  stacked
                  icon="funnel-fill"
                  variant="light"
                  flip-h
                ></b-icon>
                <b-icon
                  stacked
                  icon="filter-right"
                  variant="light"
                  shift-h="5"
                  shift-v="-1"
                  flip-v
                ></b-icon>
              </b-iconstack>
            </b-btn>
          </div>
        </b-col>
      </b-row>
      <b-row
        align-v="center"
        class="bg-light shadow-lg text-center p-1"
        v-if="isTeacher"
      >
        <b-col>
          <template>
            <b-btn
              @click="goTimeline"
              size="sm"
              variant="none"
              v-b-tooltip.hover.bottom="'Ordre antichronologique'"
            >
              <b-icon variant="primary" icon="clock"></b-icon>
            </b-btn>
            <b-btn
              @click="goKeyword"
              size="sm"
              variant="none"
              v-b-tooltip.hover.bottom="'Mots clés'"
            >
              <b-icon variant="primary" icon="flower2"></b-icon>
            </b-btn>
            |
            <b-btn
              @click="goArborescence"
              size="sm"
              variant="none"
              v-b-tooltip.hover.bottom="'Arborescence'"
            >
              <b-icon variant="primary" icon="diagram3"></b-icon>
            </b-btn>
            <b-btn
              @click="goStats"
              size="sm"
              variant="none"
              v-b-tooltip.hover.bottom="'Statistiques'"
            >
              <b-icon variant="primary" icon="pie-chart"></b-icon>
            </b-btn>
          </template>
        </b-col>
      </b-row>
      <b-card
        bg-variant="highblue"
        v-if="routeIsAnswer && branchInfo.nickname"
        no-body
      >
        <b-card-text class="p-2">
          <b-row align-h="center" align-v="center" no-gutters>
            <b-col cols="auto" class="mr-3 mb-2">
              <b-iconstack class="msg-type-icon" font-scale="2">
                <b-icon stacked icon="chat-fill" variant="primary"></b-icon>
                <b-icon
                  stacked
                  icon="chat"
                  variant="primary"
                  shift-h="3"
                  shift-v="-1"
                  flip-h
                ></b-icon>
              </b-iconstack>
            </b-col>
            <b-col cols="10" sm="8" class="short-text">
              {{ branchInfo.nickname }} -
              <span :class="`text-${typeMap[branchInfo.type].variant}`">{{
                typeMap[branchInfo.type].text
              }}</span>
              {{ branchInfo.comment }}
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
      <!-- start: sub-navbar  -->
      <b-row
        v-if="comments.filters.type && routeIsTypeFilter"
        class="bg-light shadow-sm border-top border-bottom"
      >
        <b-col>
          <div class="text-secondary pl-2 m-2">
            <b-icon icon="funnel-fill" class="mr-2" font-scale="1.2"></b-icon
            >{{ typeMap[comments.filters.type].text }}
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="
          !isFlaggedFilter &&
            comments.filters.user &&
            $route.name == 'deliberation.byUrl'
        "
        class="bg-light shadow-sm border-top border-bottom"
      >
        <b-col>
          <div class="text-secondary pl-2 m-2">
            <h5><small>Mes messages</small></h5>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="
          comments.filters.discussion && $route.name == 'deliberation.byUrl'
        "
        class="bg-light shadow-sm border-top border-bottom"
      >
        <b-col>
          <div class="text-secondary pl-2 m-2">
            <h5><small>Discussions </small></h5>
            <small
              >Les publications ci-dessous ont commencé une discussion</small
            >
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="isFlaggedFilter && $route.name == 'deliberation.byUrl'"
        class="bg-light shadow-sm border-top border-bottom"
      >
        <b-col>
          <div class="text-secondary pl-2 m-2">
            <h5>
              <small>
                {{
                  this.isStudent
                    ? "Mes publications signalées"
                    : "Publication(s) signalée(s)"
                }}</small
              >
            </h5>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="$route.name == 'deliberation.suggestions'"
        class="bg-light shadow-sm border-top border-bottom"
      >
        <b-col>
          <div class="text-secondary pl-2 m-2">
            <h5><small>Mes suggestions</small></h5>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="$route.name == 'deliberation.messages'"
        class="bg-light shadow-sm border-top border-bottom"
      >
        <b-col>
          <div class="text-secondary pl-2 m-2">
            <h5>
              <small>
                {{
                  this.isStudent ? "Messages de l'enseignant" : "Les messages"
                }}</small
              >
            </h5>
          </div>
        </b-col>
      </b-row>
      <!-- end: sub-navbar  -->
    </div>
    <!-- start: dlibr menu -->
    <b-sidebar
      bg-variant="white"
      right
      backdrop
      id="filters-menu"
      title="Filtrer les commentaires"
      shadow
    >
      <template v-slot:default="{ hide }">
        <div class="container-fluid mt-2">
          <b-btn
            size="sm"
            :variant="batchActionSelected == 1 ? 'primary' : 'none'"
            pill
            @click="filterComments({ type: 1 }, hide)"
          >
            {{ typeMap[1].text }}
          </b-btn>
          |
          <b-btn
            size="sm"
            :variant="batchActionSelected == 2 ? 'primary' : 'none'"
            pill
            @click="filterComments({ type: 2 }, hide)"
          >
            {{ typeMap[2].text }}
          </b-btn>
          |
          <b-btn
            size="sm"
            :variant="batchActionSelected == 3 ? 'primary' : 'none'"
            pill
            @click="filterComments({ type: 3 }, hide)"
          >
            {{ typeMap[3].text }}
          </b-btn>

          <div class="my-5">
            <b-btn
              v-if="isStudent"
              :variant="batchActionSelected == 'user' ? 'primary' : 'light'"
              block
              class="text-right"
              @click="filterComments({ user: profile.id }, hide)"
            >
              Voir que mes publications
            </b-btn>
            <b-btn
              :variant="
                batchActionSelected == 'discussion' ? 'primary' : 'light'
              "
              block
              class="text-right"
              @click="filterComments({ discussion: true }, hide)"
            >
              Afficher les discussions uniquement
            </b-btn>
            <b-btn
              :variant="!Boolean(batchActionSelected) ? 'primary' : 'light'"
              block
              class="text-right"
              @click="filterComments({}, hide)"
            >
              {{
                routeIsAnswer
                  ? "Retour à la délibération"
                  : "Voir toutes les publications"
              }}
            </b-btn>
            <b-btn
              v-if="isStudent || isTeacher"
              :variant="batchActionSelected == 'flagged' ? 'primary' : 'light'"
              block
              class="text-right"
              @click="filterComments(flaggedFormat, hide)"
            >
              {{
                isStudent
                  ? "Mes publications signalées"
                  : "Voir publication(s) signalée(s)"
              }}
            </b-btn>
            <template v-if="isTeacher">
              <b-btn
                variant="light"
                block
                class="text-right"
                v-b-modal.generalMessageModal
              >
                Envoyer un message à tous les participants
              </b-btn>
              <b-btn
                :variant="
                  batchActionSelected == 'deliberation.messages'
                    ? 'primary'
                    : 'light'
                "
                block
                class="text-right"
                v-b-toggle.filters-menu
                @click="goToFilter('deliberation.messages')"
              >
                Voir ma boite de messages
              </b-btn>
            </template>
            <template v-if="isStudent">
              <div class="position-relative my-2">
                <span
                  class="fa-stack suggestion-icon"
                  v-if="jobs.showSuggestionIcon"
                >
                  <font-awesome-icon
                    :icon="['fas', 'circle']"
                    class="text-warning fa-stack-2x"
                    transform=" shrink-4"
                  />
                  <font-awesome-icon
                    :icon="['far', 'lightbulb']"
                    class="text-white fa-stack-1x"
                    transform=" shrink-1"
                  />
                </span>
                <b-btn
                  id="tooltip-suggestion"
                  :variant="
                    batchActionSelected == 'deliberation.suggestions'
                      ? 'primary'
                      : 'light'
                  "
                  block
                  class="text-right"
                  @click="goToFilter('deliberation.suggestions')"
                  v-b-toggle.filters-menu
                >
                  Mes suggestions
                </b-btn>
              </div>
              <b-btn
                :variant="
                  batchActionSelected == 'deliberation.messages'
                    ? 'primary'
                    : 'light'
                "
                block
                class="text-right"
                @click="goToFilter('deliberation.messages')"
                v-b-toggle.filters-menu
              >
                Voir les messages de l'enseignant
                <b-icon
                  icon="exclamation-circle-fill"
                  variant="warning"
                  v-if="jobs.showGlobalMsgIcon"
                ></b-icon>
              </b-btn>
            </template>
            <hr class="my-3" />
            <div class="d-flex flex-column">
              <b-btn
                class="text-right"
                @click="
                  goKeyword();
                  batchActionSelected = -1;
                "
                size="sm"
                variant="none"
              >
                Mots clés
                <b-icon variant="info" icon="flower2"></b-icon>
              </b-btn>

              <b-btn
                class="text-right"
                @click="
                  goArborescence();
                  batchActionSelected = -1;
                "
                size="sm"
                variant="none"
              >
                Arborescence
                <b-icon variant="info" icon="diagram3-fill"></b-icon>
              </b-btn>
              <b-btn
                class="text-right"
                @click="
                  goStats();
                  batchActionSelected = -1;
                "
                size="sm"
                variant="none"
              >
                Stats
                <b-icon variant="info" icon="pie-chart-fill"></b-icon>
              </b-btn>
            </div>
          </div>
        </div>
      </template>
      <b-nav vertical class="text-center">
        <template
          v-if="$route.name == 'home' || $route.name == 'teachers.register'"
        >
          <b-nav-item :to="{ name: 'home' }" @click="scrollIntoView('pedago')"
            >Approche pédagogique</b-nav-item
          >
          <b-nav-item :to="{ name: 'home' }" @click="scrollIntoView('droit')"
            >Droits d'utilisation</b-nav-item
          >
          <b-nav-item
            :to="{ name: 'home' }"
            @click="scrollIntoView('generique')"
            >Générique</b-nav-item
          >
          <b-nav-item :to="{ name: 'teachers.register' }"
            >Demande d'accès</b-nav-item
          >
          <b-nav-item :to="{ name: 'auth.login.options' }"
            >Connexion</b-nav-item
          >
        </template>
        <template
          v-else-if="$route.name ? $route.name.includes('teacher') : false"
        >
          <b-nav-item
            :active="
              ['teacher.own.deliberations', 'teachers.deliberations'].includes(
                $route.name
              )
            "
            :to="{
              name: 'teacher.own.deliberations',
              params: { id: profile.id }
            }"
            >Vos délibérations</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'teachers.participants'"
            :to="{ name: 'teachers.participants', params: { id: profile.id } }"
            >Participants</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'teachers.groups'"
            :to="{ name: 'teachers.groups', params: { id: profile.id } }"
            >Groupes</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'teachers.evaluations'"
            :to="{ name: 'teachers.evaluations', params: { type: 'grille' } }"
            >Évaluations</b-nav-item
          >
        </template>
        <template
          v-else-if="$route.name ? $route.name.includes('admin') : false"
        >
          <b-nav-item
            :active="$route.name == 'admin.notifications'"
            :to="{ name: 'admin.notifications' }"
            >Notifications</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'admin.users'"
            :to="{ name: 'admin.users' }"
            >Utilisateurs</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'admin.rules'"
            :to="{ name: 'admin.rules' }"
            >Règles</b-nav-item
          >
        </template>
        <template
          v-else-if="$route.name ? $route.name.includes('student') : false"
        >
          <b-nav-item
            :active="$route.name == 'student.deliberations'"
            :to="{ name: 'student.deliberations' }"
            >Mes Délibérations</b-nav-item
          >
          <b-nav-item
            :active="$route.name == 'student.results'"
            :to="{ name: 'student.results', params: { id: profile.id } }"
            >Résultats</b-nav-item
          >
        </template>
      </b-nav>
    </b-sidebar>
    <!-- end: dlibr menu -->
    <b-sidebar
      id="dlibr-title-sidebar"
      lazy
      backdrop
      :sidebar-class="{ 'custom top': !routeIsAnswer }"
      bg-variant="primary"
      text-variant="info"
    >
      <div class="container my-5">
        <h4>Titre</h4>
        <u
          ><b-link
            class="text-info"
            :to="{
              name: 'deliberation.byUrl',
              params: {
                teacher: dlibr.teacher.id,
                url: dlibr.url
              }
            }"
          >
            <p>{{ dlibr.title }}</p>
          </b-link>
        </u>
        <h4>Description</h4>
        <p>
          {{ dlibr.description }}
        </p>

        <small class="text-light" v-if="routeIsAnswer">
          Voici la publication qui a commencé cette nouvelle discussion:</small
        >

        <div v-if="routeIsAnswer && branchInfo.nickname">
          <b-card>
            <b-iconstack class="msg-type-icon" font-scale="1.5">
              <b-icon stacked icon="chat-fill" variant="primary"></b-icon>
              <b-icon
                stacked
                icon="chat"
                variant="primary"
                shift-h="3"
                shift-v="-1"
                flip-h
              ></b-icon>
            </b-iconstack>
            <div class="text-primary">{{ branchInfo.nickname }}</div>
            <small class="text-muted"
              >{{ branchInfo.created_at | formatDateTime }}
            </small>
            <b-card-text v-if="Boolean(branchInfo.masked)">
              <div class="text-center">
                <b-icon
                  icon="eye-slash"
                  font-scale="3"
                  animation="fade"
                ></b-icon>
                <p>Publication masquée pour tous.</p>
              </div>
            </b-card-text>
            <b-card-text v-else>
              <span :class="`text-${typeMap[branchInfo.type].variant}`">{{
                typeMap[branchInfo.type].text
              }}</span>
              <p class="text-dark">
                {{ branchInfo.comment }}
              </p>
            </b-card-text>
          </b-card>
        </div>
      </div>
    </b-sidebar>
    <GeneralMessageModal />
  </header>
</template>

<script>
/**
 * @file       Layout deliberation navigation bar component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import GeneralMessageModal from "@/modules/comments/components/generalMessageModal.vue";
import { commentsMixin } from "@/modules/comments/mixins";
import { mapState } from "vuex";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "siteNavbar",
  components: { GeneralMessageModal },
  data() {
    return {
      branchInfo: {
        nickname: null,
        type: null,
        comment: null,
        created_at: null,
        masked: null
      },
      routeIsTypeFilter: true
    };
  },
  mixins: [commentsMixin],

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      ifAuthenticated: state => !!state.auth.profile.data
    }),

    /**
     * Current user's initials.
     *
     * @return      {string}  Initials of name or nickname
     */
    userInitials() {
      return this.profile.name
        ? `${this.profile.name.charAt(0)}${this.profile.last_name.charAt(0)}`
        : this.profile.nickname
        ? this.profile.nickname.slice(0, 2)
        : "";
    },

    /**
     * Check if the user is an admin.
     *
     * @return      {Bool}  true or false
     */
    userIsAdmin() {
      return (
        this.$store.state.auth.profile.data.data.find(u => u).role ==
        "ROLE_ADMIN"
      );
    },

    /**
     * Root comment.
     *
     * @return      {Object}  The root comment
     */
    rootComment() {
      return this.comments.data.root_comment;
    },

    /**
     * Flagged format.
     *
     * @return      {Object}  The flagged format
     */
    flaggedFormat() {
      return this.isStudent
        ? { flagged: 1, user: this.profile.id }
        : { flagged: 1 };
    },

    /**
     * Route name.
     *
     * @return      {string}  The route name
     */
    getRouteName() {
      return this.$route.name;
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Scroll element into the view.
     *
     * @param      {Object}  elem     The element to scroll into the view
     */
    scrollIntoView(elem) {
      document.getElementById(elem).scrollIntoView({ behavior: "smooth" });
    },

    /**
     * Logout.
     */
    onLogout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$router.push({ name: "auth.login.options" });
      });
    },

    /**
     * Go to deliberation arborescence.
     */
    goArborescence() {
      this.goToFilter("deliberation.arborescenceGraph");
    },

    /**
     * Go to deliberation keyword graph.
     */
    goKeyword() {
      this.goToFilter("deliberation.keywordGraph");
    },

    /**
     * Go to deliberation statistics.
     */
    goStats() {
      this.goToFilter("deliberation.statsGraph");
    },

    /**
     * Go to deliberation by URL.
     */
    goTimeline() {
      this.goToFilter("deliberation.byUrl");
    },

    /**
     * Go back.
     */
    goBack() {
      this.$router.push({
        name: this.isTeacher
          ? "teacher.own.deliberations"
          : "student.own.deliberations",
        params: { id: this.profile.id }
      });
      this.$store.commit("comments/setFlowDlibr", {
        fields: { evalMode: false }
      });
    },

    /**
     * Reset branch information.
     */
    resetBranchInfo() {
      this.branchInfo = {
        nickname: null,
        type: null,
        comment: null,
        created_at: null,
        masked: null
      };
    }
  },

  /**
   * Watches.
   * 
   * @type  {Object}
   */
  watch: {
    /**
     * Root comment.
     */
    rootComment: {
      handler: function(val) {
        if (!this.isFilter) {
          this.resetBranchInfo();
        }
        if (val) {
          this.branchInfo.nickname = val.user.nickname;
          this.branchInfo.type = val.type;
          this.branchInfo.comment = val.comment;
          this.branchInfo.created_at = val.created_at;
          this.branchInfo.masked = val.masked;
        }
      },
      deep: true
    },

    /**
     * Route name.
     */
    getRouteName: {
      handler: function(val) {
        if (
          val == "deliberation.byUrl" ||
          val == "deliberation.byUrl.answers"
        ) {
          this.routeIsTypeFilter = true;
          this.batchActionSelected = -1;
        } else {
          this.routeIsTypeFilter = false;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.b-sidebar > .b-sidebar-header {
  font-size: 1rem;
}
header .fixed {
  position: fixed;
  width: 100%;
  z-index: 15;
  top: 0;
  left: 0;
}
.text-ellipsis {
  cursor: pointer;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.short-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  font-size: 0.85rem;
}

.suggestion-icon {
  position: absolute;
  outline: none !important;
  top: 3px;
  right: 150px;
  &.top {
    position: absolute;
    right: 20px;
    top: 3px;
  }
}
</style>
